import {
  chainIdToVaultNetwork,
  TChainId,
  vaultConfiguration,
} from 'modules/api';
import { getExtendedErrorText } from 'modules/common/utils/getExtendedErrorText';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { web3Api } from 'store/web3Api';

interface Args {
  address?: string;
  chainId?: TChainId;
}

interface IWithdrawalRequest {
  amount: number;
  blockNumber: number;

  offerToken: string;
  timestamp: number;
  transaction_hash: string;
  user: string;
  wantToken: string;

  wantTokenAmount: string;
  wantTokenDecimals: number;
  wantTokenSymbol: string;

  metadata: {
    amountOfAssets: number;
    amountOfShares: number;
    assetOut: string;
    creationTime: number;
    nonce: number;
    secondsToDeadline: number;
    secondsToMaturity: number;
    user: string;
  };
}

interface WithdrawRequests {
  cancelled_requests: IWithdrawalRequest[];
  expired_requests: IWithdrawalRequest[];
  fulfilled_requests: IWithdrawalRequest[];
  open_requests: IWithdrawalRequest[];
}

interface ApiResponse {
  Response: WithdrawRequests;
}

export const {
  useGetWithdrawalStatusQuery,
  endpoints: { getWithdrawalStatus },
} = web3Api.injectEndpoints({
  endpoints: build => ({
    getWithdrawalStatus: build.query<WithdrawRequests, Args | undefined>({
      queryFn: queryFnNotifyWrapper<Args, never, WithdrawRequests>(
        async ({ address, chainId }) => {
          if (!address || !chainId) throw new Error('Invalid args');
          const network = chainIdToVaultNetwork(chainId);

          const response = await fetch(
            `https://api.sevenseas.capital/boringQueue/${network}/${vaultConfiguration.vaultContract}/${address}`,
          );

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data: ApiResponse = await response.json();
          return {
            data: data.Response,
          };
        },
        error => getExtendedErrorText(error, 'Failed to get withdrawal status'),
      ),
    }),
  }),
});
